import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["_use", "children"];
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { filterProps } from '../../../utils/filterProps';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTooltipContent = styled.div.withConfig({
  displayName: "TooltipContent__StyledTooltipContent",
  componentId: "sc-16qnjtw-0"
})(({
  $use,
  $cssStyles,
  theme
}) => {
  return Object.assign({
    '> :last-child': {
      marginBlockEnd: $use === 'longform' ? theme.space['0'] : undefined
    }
  }, $cssStyles);
});
export const TooltipContent = _ref => {
  let {
      _use,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledTooltipContent, Object.assign({}, domProps, {
    $use: _use,
    $cssStyles: cssStyles,
    children: children
  }));
};